import Intercom from './Intercom/Intercom';

export default Intercom;
